import { extendObservable, toJS } from 'mobx'
import pickBy from 'lodash/pickBy'
import moment from 'moment'
import PCancelable from 'p-cancelable'

import { getParentAccountSuggestions, getAccountSuggestions, financialRevenueApi } from '@atheneum/api'

class FinancialRevenue {
  constructor (staticData) {
    extendObservable(this, {
      loading: null,
      error: null,
      staticData,
      count: null,
      entries: [],
      query: this.getEmptyQuery(),
      parentAccountSuggestion: '',
      accountSuggestion: '',
      toInvoiceAmount: null
    })
  }

  entryTypes = [
    { value: 'fee-allocated', label: 'Allocated fees' },
    { value: 'fee-unallocated', label: 'Unallocated fees' },
    { value: 'invoice', label: 'Invoices' },
    { value: 'adjustment-fee', label: 'Fee adjustments' },
    { value: 'adjustment-general', label: 'General adjustments' }
  ]

  getEmptyQuery () {
    return {
      entryTypes: [],
      fromDate: moment().subtract(1, 'month'),
      toDate: moment(),
      parentAccountId: null,
      accountId: null,
      contractTypeIds: [],
      limit: 20,
      page: 1
    }
  }

  filter = () => {
    const cancelableGetEntries = PCancelable.fn(financialRevenueApi.getEntries)
    const preparedQuery = {
      ...pickBy(toJS(this.query)),
      entryTypes: this.query.entryTypes.slice().map(entry => entry.value),
      fromDate: moment(this.query.fromDate).format('YYYY-MM-DD'),
      toDate: moment(this.query.toDate).format('YYYY-MM-DD')
    }

    if (this.loading) {
      this.loading.cancel()
    }

    this.loading = cancelableGetEntries(preparedQuery)

    this.loading
      .then(results => {
        this.entries.replace(results.rows)
        this.count = results.count
        this.loading = null
        this.error = null
      })
      .catch(err => {
        if (!err.isCanceled) {
          this.error = err
        }
        this.loading = null
      })
  }

  autocompleteParentAccount = value => {
    if (!value) return Promise.resolve([])

    return getParentAccountSuggestions(value).then(result => {
      const autocompleteResult = result.map(element => {
        const suggestion = {
          value: element.id,
          label: element.parentAccountName
        }
        return suggestion
      })
      return autocompleteResult
    })
  }

  autocompleteAccount = value => {
    if (!value) return Promise.resolve([])

    return getAccountSuggestions(value).then(result => {
      const autocompleteResult = result.map(element => {
        const suggestion = {
          value: element.id,
          label: element.companyName
        }
        return suggestion
      })
      return autocompleteResult
    })
  }

  clearSearch () {
    this.query = this.getEmptyQuery()
    this.parentAccountSuggestion = ''
    this.accountSuggestion = ''
    this.filter()
  }

  getToInvoiceAmount () {
    return financialRevenueApi.getToInvoiceAmount().then(amount => {
      this.toInvoiceAmount = amount
      return amount
    })
  }
}

export default FinancialRevenue
